import EVENT_TYPE_SETTINGS from '@/modules/events/constants/event-types-settings.constant';

export default class EventsSettingsModel {
    countries: string[] = [];
    types: EVENT_TYPE_SETTINGS[] = [];
}
